import theme from '../themes/default'
import arrowImage from '../../images/select_dropdown_arrow.png'

export default {
  'takeaway-summary-wrap': {
    background: 'rgb(246,242,234)',
    'overflow-y': 'scroll',
  },
  'takeaway-summary-cover': {
    height: '80px',
    'margin-top': '10px',
    'margin-bottom': '15px',
    background: '#fff',
    'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
    'object-fit': 'contain',
  },
  'takeaway-summary-h1': {
    'font-size': '22px',
    'margin-top': '8px',
    'margin-bottom': '8px',
    position: 'relative',
  },
  'takeaway-summary-header': {
    'font-size': '18px',
    'margin-top': '8px',
    'margin-bottom': '8px',
    position: 'relative',
  },
  'takeaway-summary-sub-header': {
    'font-size': '10px',
    color: '#A59996',
    'margin-top': '10px',
    'margin-bottom': '5px',
  },
  'takeaway-reorder-line': {
    display: 'flex',
    'justify-content': 'center',
    'font-size': '1.2em',
  },
  'takeaway-summary-waiting-code': {
    'font-size': '50px',
    border: '1px',
    marginLeft: '0px',
    margin: '0px',
    position: 'relative',
  },
  'takeaway-summary-waiting-code-boundary': {
    'font-size': '50px',
    border: '1px',
    width: '100%',
    height: '50%',
    position: 'absolute',
    bottom: '0',
    left: '0',
    // 'border-top-style': 'solid',
    'border-left-style': 'solid',
    'border-bottom-style': 'solid',
    'border-color': '#D8D8D8',
    margin: '0px',
    'line-height': '50%',
    overflow: 'visible',
  },
  'takeaway-summary-waiting-code-boundary-last': {
    'font-size': '50px',
    border: '1px',
    width: '100%',
    height: '50%',
    position: 'absolute',
    bottom: '0',
    right: '0',
    'border-left-style': 'solid',
    'border-right-style': 'solid',
    'border-bottom-style': 'solid',
    'border-color': '#D8D8D8',
    margin: '0px',
    'line-height': '50%',
    overflow: 'visible',
  },
  'takeaway-summary-content': {
    'font-size': '12px',
  },
  'takeaway-summary-cover-container': {
    width: '100%',
    textAlign: 'center',
  },
  'delivery-select-container': {
    overflow: 'visible',
  },
  'takeaway-summary-info-container': {
    background: '#fff',
    'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
    'border-top-left-radius': '15px',
    'border-top-right-radius': '15px',
    'border-bottom-left-radius': '15px',
    'border-bottom-right-radius': '15px',
    '& > div:nth-child(2)': {
      'border-bottom': 'none !important',
      'padding-bottom': '0 !important',
    },
    'margin-top': '10px',
    'margin-left': '15px',
    'margin-right': '15px',
    'margin-bottom': '20px',
    padding: '10px 20px',
    'padding-left': '25px',
  },
  'takeaway-summary-tel-input': {
    padding: 10,
    marginLeft: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
    borderRadius: 5,
  },
  'takeaway-summary-tel-input::placeholder': {
    color: '#A2A2A2',
  },
  'takeaway-summary-address-input': {
    width: 'calc(100% - 22px)',
    padding: '10px',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
    borderRadius: 5,
  },
  'takeaway-summary-address-optional-input': {
    height: 16,
    width: 'calc(100% - 22px)',
    padding: '10px',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
    borderRadius: 5,
  },
  'takeaway-summary-time-select': {
    flex: 1,
    borderColor: '#D8D8D8',
    backgroundColor: '#fff',
    width: '100%',
    padding: 10,
    fontSize: 14,
    lineHeight: '1',
    // 'color': '#A2A2A2',
    // border: 0;
    borderRadius: 5,
    // height: 34px;
    background: `url(${arrowImage}) no-repeat right #ddd`,
    '-webkit-appearance': 'none',
    'background-position-x': 'calc(100%)',
  },
  'takeaway-summary-shop-time-select': {
    flex: 1,
    borderColor: '#D8D8D8',
    backgroundColor: '#fff',
    width: '100%',
    padding: 10,
    marginLeft: 8,
    fontSize: 14,
    lineHeight: '1',
    // 'color': '#A2A2A2',
    // border: 0;
    // border-radius: 5px;
    // height: 34px;
    background: `url(${arrowImage}) no-repeat right #ddd`,
    '-webkit-appearance': 'none',
    'background-position-x': 'calc(100%)',
  },
  'takeaway-summary-shop-date-select': {
    flex: 1,
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: 10,
    marginRight: 8,
    fontSize: 14,
    lineHeight: 1,
    width: '100%',
    // color: '#A2A2A2',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
    borderRadius: 5,
    position: 'relative',
    // height: 34px;
    background: `url(${arrowImage}) no-repeat right #ddd`, // > customized arrow down indicator.
    // '-webkit-appearance': 'none',
    // 'background-position-x': 'calc(100%)',
    '&::-webkit-inner-spin-button': {
      // > hide the default inner spin button.
      display: 'none',
      ' -webkit-appearance': 'none',
    },
    '&::-webkit-calendar-picker-indicator': {
      // > make the default indicator cover the hole input division.
      // > can click any where of the input to open the date selector.
      background: 'transparent',
      color: 'transparent',
      width: 'auto',
      cursor: 'pointer',
      height: 'auto',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    '&::-webkit-clear-button': {
      display: 'none',
    },
  },
  // 'takeaway-summary-time-select select': {
  //     '-moz-appearance': 'none', /* Firefox */
  //     '-webkit-appearance': 'none', /* Safari and Chrome */
  //     'appearance': 'none'
  // }
  'takeaway-summary-footer': {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    background: '#4A8CA1',
    height: '70px',
    color: '#fff',
    'text-align': 'center',
    'font-size': '16px',
    'line-height': '70px',
    'vertical-align': 'middle',
    // 'box-shadow': '0 -11px 21px 0 rgba(0, 0, 0, 0.26)',
    'z-index': '9',
  },
  'takeaway-summary-footer-invalid': {
    background: '#D8D8D8',
  },

  'loading-sign': {
    flex: 1,
    height: 36,
    justifyContent: 'center',
  },
  'takeaway-summary-tel-input-valid': {
    'border-color': '#D8D8D8',
  },
  'takeaway-summary-tel-input-invalid': {
    'border-color': '#FF0000',
  },
  'bg-shape': {
    width: '15px',
    height: '13px',
    position: 'absolute',
    background: '#ffefc2',
    'border-bottom-right-radius': '15px',
    'border-top-right-radius': '15px',
  },
  'bg-shape-checkout': {
    top: '5px',
    left: '-25px',
  },
  'code-wrap': {
    marginTop: '20px',
    overflow: 'visible',
  },
  'waiting-code-wrap': {
    marginTop: '20px',
  },
  'pickup-at-text': {
    fontSize: '14px',
  },
  'merchant-contact-wrap': {
    borderBottom: '1px solid #e5e5e5',
    padding: '0px 0px 15px 0',
    marginBottom: '15px',
  },
  'cooking-img': {
    height: '20px',
    verticalAlign: 'bottom',
  },
  'takeaway-order-status-wrap': {
    verticalAlign: 'bottom',
    lineHeight: '18px',
    height: '18px',
    position: 'relative',
    marginLeft: '15px',
    'min-width': '100px',
  },
  '@keyframes blink': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  'takeaway-order-status-text': {
    fontSize: '14px',
    color: 'inherit',
    marginLeft: '5px',
  },
  'takeaway-order-status-text-highlight': {
    fontSize: '14px',
    color: 'inherit',
    marginLeft: '5px',
    animation: 'blink 1s infinite',
  },
  'takeaway-order-status-text-cancelled': {
    fontSize: '14px',
    color: '#C54545',
    marginLeft: '5px',
    whiteSpace: 'break-spaces',
  },
  'takeaway-status-body': {
    marginTop: '50px',
    marginBottom: '20px',
    position: 'relative',
  },
  'resubmit-button': {
    background: '#614D4A',
    width: 53,
    height: 25,
    padding: 5,
    marginLeft: 5,
    color: '#fff',
    textAlign: 'center',
    borderRadius: 12.5,
  },
  'resubmit-after-order-complete-button': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#614D4A',
    width: 200,
    height: 25,
    padding: 5,
    marginLeft: 5,
    color: '#fff',
    textAlign: 'center',
    borderRadius: 12.5,
  },
  'resubmit-after-order-complete-button-disabled': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ccc',
    width: 200,
    height: 25,
    padding: 5,
    marginLeft: 5,
    color: '#fff',
    textAlign: 'center',
    borderRadius: 12.5,
  },
  'takeaway-order-status-content-wrap': {
    width: '100%',
    display: 'flex',
    'justify-content': 'space-between',
    'align-items': 'center',
  },
  divider: {
    borderBottom: '1px solid #e5e5e5',
    padding: '0px 0px 15px 0',
    marginBottom: '15px',
  },
  'wechat-pay-modal': {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.2)',
    position: 'fixed',
    zIndex: '2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  'wechat-pay-dialog': {
    width: '520px',
    height: '280px',
    maxWidth: '80vw',
    backgroundColor: 'white',
    borderRadius: '2',
    padding: '18px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  'wechat-pay-title': {
    wordBreak: 'keep-all',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    margin: '15px',
  },
  'wechat-paid-btn': {
    'background-color': '#D5AD40',
    'border': '1PX solid #D5AD40'
  }
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/TakeawaySummary.js